import SubHeader from '../../layout/components/SubHeader';
import EyeDrawHome from './EyeDrawHome'
const EyeDrawNew = () => {
    return ( 
        <>
            <SubHeader title="Eye Draw" description={"Select a card to draw on it"}/>
            <EyeDrawHome/>
        </>
     );
}
 
export default EyeDrawNew;